<script setup>
import { ref, watch } from 'vue';
import DsCheckSwitch from 'JIX/components/ds/DsCheckSwitch.vue';
import { getCookie, setCookie } from 'JIX/utils/cookies';

import { __ } from 'JIX/gettext.js';

const JIX_NEW_JOBSEARCH_COOKIE = 'jix-new-jobsearch';

const newJobsearch = ref(Number(getCookie(JIX_NEW_JOBSEARCH_COOKIE) ?? window.Stash.common.new_jobsearch_default) === 1);

watch(newJobsearch, () => {
    setCookie(JIX_NEW_JOBSEARCH_COOKIE, newJobsearch.value ? 1 : 0, { path: '/', samesite: 'Lax' });
    if (window.jixAnalytics) {
        const label = newJobsearch.value ? 'opt-in' : 'opt-out';
        window.jixAnalytics('event', { category: 'jobsearch-version-1', action: 'click', label });
    }
    const url = location.href;
    location.href = url;
});

</script>

<template>
    <div class="position-relative">
        <DsCheckSwitch v-model="newJobsearch">
            {{ __('Prøv ny jobsøgning') }}
        </DsCheckSwitch>
    </div>
</template>
